import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Grid, Paper, Typography, units } from '@hbf/dsl';
import { ContentfulImg } from 'ha/modules/Contentful/components/ContentfulImg';
import { useSelector } from 'react-redux';
import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';
import { ValuePropositionData } from './types';

const useStyles = makeStyles()(theme => ({
  img: {
    maxHeight: units.rem(5),
  },
  imgWrapper: {
    background: `linear-gradient(to right bottom, white, rgb(234, 240, 244))`,
    padding: units.rem(2),
  },
  textWrapper: {
    backgroundColor: theme.palette.white.main,
    padding: units.rem(1.5),
  },
  title: {
    marginBottom: units.rem(0.5),
  },
  container: {
    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  fullHeight: {
    height: '100%',
  },
}));

export interface Props {
  valueProposition: ValuePropositionData;
}

export const VpCompact: React.FC<Props> = ({ valueProposition }) => {
  const { classes, cx } = useStyles();
  // Remove the following line after https://github.com/housinganywhere/src/pull/1505 got merged.
  const image = valueProposition.imageAsset || {
    fields: { url: valueProposition.image },
  };

  const lang = useSelector(getCurrentLanguageCode);
  const desc = image.fields.description;
  const alt = desc ? desc[lang] || desc.en : '';

  return (
    <Paper elevation={1} className={classes.fullHeight}>
      <Grid container className={cx(classes.container, classes.fullHeight)}>
        <Grid item className={classes.imgWrapper}>
          <Grid
            container
            justifyContent="center"
            alignContent="center"
            className={classes.fullHeight}
          >
            <div>
              <ContentfulImg
                src={image.fields.url}
                alt={alt}
                role="presentation"
                className={classes.img}
                defaultSrc={image.fields.url}
                sizes={{ xs: '320px' }}
              />
            </div>
          </Grid>
        </Grid>
        <Grid item className={classes.textWrapper}>
          <Typography.H2 component="h3" className={classes.title}>
            {valueProposition.title}
          </Typography.H2>
          <Typography.Paragraph>
            {valueProposition.description}
          </Typography.Paragraph>
        </Grid>
      </Grid>
    </Paper>
  );
};
